import React from 'react'
import styled from 'styled-components'
import Simulator from 'components/molecules/Simulator'
import Slider from 'react-slick'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'frontend_core/dist/styles/colors'
// import Icon from 'components/atoms/FaIcon'
import Icon from 'components/atoms/Icon'
import { imagePath } from 'frontend_core/dist/helpers/image'

const MCarousel = styled.div`
  background: ${Colors.white};
  border-radius: 3px;
  margin-top: 20px;
  overflow: hidden;
  padding-bottom: 8px;
  &:first-child {
    margin-top: 0;
  }
  ${mediaMin.phone`
    background: ${Colors.grayF};
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
    max-width: 680px;
    margin: 0 auto 16px;
    padding-bottom: 0;
    position: relative;
    &::before {
      content:'';
      position: absolute;
      top: 0;
      right: 0;
      background-color: #fff;
      width: 52%;
      height: 100%;
      z-index: 1;
    }
    &::after {
      content:'';
    }
  `};
`
const CarouselHeadWrap = styled.div`
  ${mediaMin.phone`
    width: 48%;
    float: left;
  `};
`
const CarouselHeader = styled.div`
  background: ${Colors.black};
  padding: 10px 16px;
  border-radius: 3px 3px 0 0 / 3px 3px 0 0;
  text-align: right;
  ${mediaMin.phone`
    padding: 16px;
    border-radius: 3px 0 0 0;
  `};
`
const ACarouselSales = styled.p`
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  padding-right: 10px;
  color: ${Colors.white};
`
const ACarouselAmount = styled.p`
  display: inline-block;
  font-size: 22px;
  font-weight: bold;
  color: ${Colors.white};
  .fa-yen-sign {
    padding-right: 3px;
  }
`
const CarouselTitleWrap = styled.div`
  display: flex;
  align-items: center;
`
const ACarouselImage = styled.img`
  width: 100%;
`
const CarouselContent = styled.div`
  padding: 16px;
  ${mediaMin.phone`
    background: ${Colors.white};
    width: 52%;
    float: right;
    height: auto;
    padding: 32px 24px;
    position: relative;
    z-index: 2;
  `};
`
const AOwnerImage = styled.img`
  width: 70px;
  height: 70px;
  flex-shrink: 0;
`
const ACarouselTitle = styled.h3`
  color: ${Colors.black};
  line-height: 1.3;
  font-weight: bold;
  padding-left: 16px;
  font-size: 16px;
`
const CarouselTextWrap = styled.div`
  margin-top: 16px;
`
const AText = styled.p`
  font-size: 16px;
  line-height: 1.6;
`
const CarouselSpaceWrap = styled.div`
  padding: 0 16px 16px;
  line-height: 1.3;
  ${mediaMin.phone`
    width: 48%;
    float: right;
    padding-top: 16px;
  `};
`
const ACarouselSpaceName = styled.p`
  font-weight: bold;
`
const CarouselSpaceTextWrap = styled.div`
  margin: 16px 0 8px;
`
const ACarouselSpaceText = styled.p`
  font-size: 12px;
  color: ${Colors.gray9};
  line-height: 1.4;
`
const ACarouselSpaceInfo = styled.p`
  font-size: 12px;
  color: ${Colors.black};
  padding-right: 8px;
  line-height: 1.4;
  .fa {
    color: ${Colors.gray9};
    font-size: 14px;
    padding: 0 5px;
  }
`

export default class HostEntry extends React.Component<*> {
  render() {
    const settings = {
      dots: true,
      speed: 500,
    }
    return (
      <Slider {...settings}>
        <MCarousel>
          <CarouselHeadWrap>
            <CarouselHeader>
              <ACarouselSales>月の売上実績：</ACarouselSales>
              <ACarouselAmount>
                <Icon className="fa fa-yen-sign" iconSize="22" />656,532
              </ACarouselAmount>
            </CarouselHeader>
            <ACarouselImage
              src={imagePath('service/lp/img-sample01.jpg')}
              alt="ASAGORO"
            />
          </CarouselHeadWrap>
          <CarouselContent>
            <CarouselTitleWrap>
              <AOwnerImage src={imagePath('service/lp/space-owner01.png')} />
              <ACarouselTitle>売上は月平均600,000円超え！</ACarouselTitle>
            </CarouselTitleWrap>
            <CarouselTextWrap>
              <AText>
                元々物件が素晴らしく、もっと多くの人にこの物件の良さを感じて欲しいと思い、スペースの貸出を始めました。スペースマーケットを利用してからはスペースとしての利用用途がかなり広がりました。法人の撮影や、最近では朗読や、落語、演劇などの個人の発表の場としても利用をされるようになりました。<br />元々自社だけで集客をしていましたがスペースマーケットのサービスは使いやすく、利用を開始してからも簡単にやり取りや売り上げの管理などを行うことができています。
              </AText>
            </CarouselTextWrap>
          </CarouselContent>
          <CarouselSpaceWrap>
            <ACarouselSpaceName>ASAGORO</ACarouselSpaceName>
            <CarouselSpaceTextWrap>
              <ACarouselSpaceText>
                23区内にありながら、木々に囲まれ築93年を超す、昔ながらの風情あふれる平屋建ての人気古民家スペース。
              </ACarouselSpaceText>
            </CarouselSpaceTextWrap>
            <ACarouselSpaceInfo>
              <Icon className="fa fa-map-marker-alt" />東京都中野区　<Icon className="fa fa-yen-sign" />3,000〜15,000円/時間<Icon className="fa fa-yen-sign" />22,000〜120,000円/日
            </ACarouselSpaceInfo>
          </CarouselSpaceWrap>
        </MCarousel>
        <MCarousel>
          <CarouselHeadWrap>
            <CarouselHeader>
              <ACarouselSales>月の売上実績：</ACarouselSales>
              <ACarouselAmount>
                <Icon className="fa fa-yen-sign" iconSize="22" />351,540
              </ACarouselAmount>
            </CarouselHeader>
            <ACarouselImage
              src={imagePath('service/lp/img-sample02.jpg')}
              alt="紫栄庵"
            />
          </CarouselHeadWrap>
          <CarouselContent>
            <CarouselTitleWrap>
              <AOwnerImage
                src={imagePath('service/lp/space-owner02.png')}
                alt=""
              />
              <ACarouselTitle>
                想定外の利用用途でホストを楽しんでいます！
              </ACarouselTitle>
            </CarouselTitleWrap>
            <CarouselTextWrap>
              <AText>
                スペースマーケットで貸出をしてからは意外にコスプレイヤーの方の撮影利用が多くとても驚きました。最初は意図していない利用用途だったので不安な気持ちもありましたが実際に貸出を行ってみるとコスプレイヤーの方は親切でマナーもよく安心して貸出をすることができました。<br />いい意味で想定外の利用用途が増えることで利用者のいろいろなニーズが知れ成約数増加に繋がっているのだと思います。自分でも考えつかなかった用途が次々見つかるのは非常に面白く、ホストを楽しんでいます。
              </AText>
            </CarouselTextWrap>
          </CarouselContent>
          <CarouselSpaceWrap>
            <ACarouselSpaceName>紫栄庵</ACarouselSpaceName>
            <CarouselSpaceTextWrap>
              <ACarouselSpaceText>
                約300坪の敷地と純和風のお庭。撮影、お茶会、着付け、食事会ほか様々に利用可能。
              </ACarouselSpaceText>
            </CarouselSpaceTextWrap>
            <ACarouselSpaceInfo>
              <Icon className="fa fa-map-marker-alt" />神奈川県横浜市神奈川区　<Icon className="fa fa-yen-sign" />3,000〜20,000/時間
            </ACarouselSpaceInfo>
          </CarouselSpaceWrap>
        </MCarousel>
        <MCarousel>
          <CarouselHeadWrap>
            <CarouselHeader>
              <ACarouselSales>月の売上実績：</ACarouselSales>
              <ACarouselAmount>
                <Icon className="fa fa-yen-sign" iconSize="22" />379,254
              </ACarouselAmount>
            </CarouselHeader>
            <ACarouselImage
              src={imagePath('service/lp/img-sample03.jpg')}
              alt="ピース"
            />
          </CarouselHeadWrap>
          <CarouselContent>
            <CarouselTitleWrap>
              <AOwnerImage
                src={imagePath('service/lp/space-owner03.png')}
                alt=""
              />
              <ACarouselTitle>
                空いている時間で賃貸以上の収益に！
              </ACarouselTitle>
            </CarouselTitleWrap>
            <CarouselTextWrap>
              <AText>
                元々自習室として運営していた施設の集客に困っており、施設を会議室に変えて運営を開始し直したタイミングで日経トレンディを見てスペースマーケットを利用し始めました。スペースマーケットで貸出を開始してからはすぐに売り上げが上がるようになり、値付けを工夫したこともあって、会議室のカテゴリーで1位を取るまでになりました。{' '}
                <br />また賃貸に出せば自社では使えなくなりますが、スペースマーケットで貸出を行うことで空いている時は自分たちで利用でき、空いている時間で賃貸以上の収益を上げることができているので非常に便利だと感じています。
              </AText>
            </CarouselTextWrap>
          </CarouselContent>
          <CarouselSpaceWrap>
            <ACarouselSpaceName>ピース</ACarouselSpaceName>
            <CarouselSpaceTextWrap>
              <ACarouselSpaceText>
                ニコニコ生放送のゲーム実況チャンネルの番組制作に利用しているスタジオや控室・小会議室を利用可能。
              </ACarouselSpaceText>
            </CarouselSpaceTextWrap>
            <ACarouselSpaceInfo>
              <Icon className="fa fa-map-marker-alt" />東京都豊島区　<Icon className="fa fa-yen-sign" />490〜￥1,080/時間<Icon className="fa fa-yen-sign" />3,980〜11,980/日
            </ACarouselSpaceInfo>
          </CarouselSpaceWrap>
        </MCarousel>
        <MCarousel>
          <CarouselHeadWrap>
            <CarouselHeader>
              <ACarouselSales>月の売上実績：</ACarouselSales>
              <ACarouselAmount>
                <Icon className="fa fa-yen-sign" iconSize="22" />2,021,500
              </ACarouselAmount>
            </CarouselHeader>
            <ACarouselImage
              src={imagePath('service/lp/img-sample04.jpg')}
              alt="hanami"
            />
          </CarouselHeadWrap>
          <CarouselContent>
            <CarouselTitleWrap>
              <AOwnerImage
                src={imagePath('service/lp/space-owner04.png')}
                alt=""
              />
              <ACarouselTitle>
                空いている時間で賃貸以上の収益に！
              </ACarouselTitle>
            </CarouselTitleWrap>
            <CarouselTextWrap>
              <AText>
                今までは飲食店舗として運営していたこともあり、個人でのパーティーでの利用が大多数でしたが、スペースマーケットを利用し始めてからは法人利用の機会が増えました。<br />特に路面店舗の特性を生かして頂き、数ヶ月単位での企業のPRイベントでご利用頂くことが多く通常どおり飲食店を営業しながら、収益を上げることができ、さらにPR効果によって通常よりも多くのお客様に足を運んでもらうこともできました。お店の新しい収益の柱ができるとは利用を開始した頃は思ってもいませんでした。
              </AText>
            </CarouselTextWrap>
          </CarouselContent>
          <CarouselSpaceWrap>
            <ACarouselSpaceName>hanami</ACarouselSpaceName>
            <CarouselSpaceTextWrap>
              <ACarouselSpaceText>
                表参道駅から徒歩3分という好立地、新築一軒家。1階はカフェスペース・2階はイベントスペースで、雰囲気の違うところも魅力。
              </ACarouselSpaceText>
            </CarouselSpaceTextWrap>
            <ACarouselSpaceInfo>
              <Icon className="fa fa-map-marker-alt" />東京都渋谷区　<Icon className="fa fa-yen-sign" />490〜￥1,080/時間<Icon className="fa fa-yen-sign" />15,000/時間<Icon className="fa fa-yen-sign" />180,000/日
            </ACarouselSpaceInfo>
          </CarouselSpaceWrap>
        </MCarousel>
        <MCarousel>
          <CarouselHeadWrap>
            <CarouselHeader>
              <ACarouselSales>月の売上実績：</ACarouselSales>
              <ACarouselAmount>
                <Icon className="fa fa-yen-sign" iconSize="22" />163,734
              </ACarouselAmount>
            </CarouselHeader>
            <ACarouselImage
              src={imagePath('service/lp/img-sample05.jpg')}
              alt="トリップモール"
            />
          </CarouselHeadWrap>
          <CarouselContent>
            <CarouselTitleWrap>
              <AOwnerImage
                src={imagePath('service/lp/space-owner05.png')}
                alt=""
              />
              <ACarouselTitle>
                運用している不動産の空室時間の稼働が増加！
              </ACarouselTitle>
            </CarouselTitleWrap>
            <CarouselTextWrap>
              <AText>
                運用している不動産の物件に空き時間があったので、少しでも空き時間を少なくできればと思い、スペースマーケットの利用を開始しました。<br />利用を始めてみると思っていた以上に運用施設とスペースマーケットの親和性が高く、本来の用途とは異なるパーティーや撮影などで空室時間の稼働が増加しました。スペースマーケットを使った空き時間の活用の可能性は今後も広がっていくと感じています。
              </AText>
            </CarouselTextWrap>
          </CarouselContent>
          <CarouselSpaceWrap>
            <ACarouselSpaceName>トリップモール</ACarouselSpaceName>
            <CarouselSpaceTextWrap>
              <ACarouselSpaceText>
                都内各所で撮影・パーティなどに利用できる様々なスペースをご提供。
              </ACarouselSpaceText>
            </CarouselSpaceTextWrap>
            <ACarouselSpaceInfo>
              <Icon className="fa fa-map-marker-alt" />東京都渋谷区　<Icon className="fa fa-yen-sign" />5,000/時間<Icon className="fa fa-yen-sign" />28,500/日
            </ACarouselSpaceInfo>
          </CarouselSpaceWrap>
        </MCarousel>
      </Slider>
    )
  }
}
